import React from "react";
import { Container } from "reactstrap";

function CapabilityCardsSection({ heading, capabilities, gridClassName = "" }) {
  const gridClassNames = ["supply-chain-capabilities-grid", gridClassName]
    .filter(Boolean)
    .join(" ");

  return (
    <section
      className="supply-chain-capabilities-section"
      aria-labelledby="supply-chain-capabilities-title"
    >
      <Container className="supply-chain-capabilities-container">
        <div className="supply-chain-capabilities-heading">
          <h2 id="supply-chain-capabilities-title">{heading}</h2>
          <span aria-hidden="true" />
        </div>
        <div className={gridClassNames}>
          {capabilities.map(capability => (
            <article
              className="supply-chain-capability-card"
              key={capability.title}
              style={{ backgroundImage: `url(${capability.image})` }}
            >
              <div className="supply-chain-capability-content">
                {capability.number && (
                  <p className="supply-chain-capability-number">{capability.number}</p>
                )}
                <h3>{capability.title}</h3>
                {(capability.items || capability.description) && (
                  <div
                    className={`supply-chain-capability-body${
                      capability.description ? " supply-chain-capability-body--description" : ""
                    }`}
                  >
                    {capability.items ? (
                      <ul>
                        {capability.items.map(item => (
                          <li key={item}>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>{capability.description}</p>
                    )}
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default CapabilityCardsSection;
